export default {
      id: "gallery-usage",
      viewBox: "0 0 80 80",
      url: "/assets/" + "icons.svg#gallery",
      toString: function () {
        return this.url;
      }
    }